import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {service} from '../redux/service'
import {imageBaseUrl} from 'src/cms/helpers/constants'

interface Props {
  md5Id: string
  handleClose: () => void
}

const Field = ({label, value}: {label: string; value?: string | number | null}) => (
  <div className='col-md-4 mb-3'>
    <div className='text-muted small'>{label}</div>
    <div className='fw-semibold'>{value ?? '-'}</div>
  </div>
)

const ViewIcardRequestDetails = ({md5Id, handleClose}: Props) => {
  const [record, setRecord] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    service
      .getIcardRequestsReportDetail(md5Id)
      .then((res) => setRecord(res.data?.data))
      .catch(() => toast.error('Failed to load icard request details.'))
      .finally(() => setLoading(false))
  }, [md5Id])

  return (
    <div className='modal show d-block' style={{background: 'rgba(0,0,0,0.5)'}}>
      <div className='modal-dialog modal-xl modal-dialog-scrollable'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Icard Request — {record?.full_name || md5Id}</h5>
            <button className='btn-close' onClick={handleClose} />
          </div>
          <div className='modal-body'>
            {loading ? (
              <div className='text-center py-5'>
                <div className='spinner-border text-primary' />
              </div>
            ) : !record ? (
              <div className='alert alert-danger'>Request not found.</div>
            ) : (
              <div className='row'>
                <Field label='Request Code' value={record.icard_request_code} />
                <Field label='Full Name' value={record.full_name} />
                <Field label='Date of Birth' value={record.date_of_birth} />
                <Field label='Mobile Number' value={record.mobile_number} />
                <Field label='Email Address' value={record.email_address} />
                <Field label='Account Number' value={record.account_number} />
                <Field label='Preferred Branch' value={record.branch?.title} />
                <Field label='PAN Number' value={record.pan_number} />
                <Field label='Requested Amount' value={record.requested_amount} />
                <Field label='Card Collection Date' value={record.card_collection_date} />
                <Field label='Card Type' value={record.card_type} />
                {record.citizenship_photo && (
                  <div className='col-md-6 mb-3'>
                    <label className='fw-bold d-block'>Uploaded PAN Certificate</label>
                    <a
                      href={`${imageBaseUrl}/storage/${record.citizenship_photo}`}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      View Document
                    </a>
                  </div>
                )}
                <Field label='OTP Status' value={record.otp_status} />
                <Field label='Status' value={record.status} />
                <Field label='Submitted At' value={record.created_at} />
              </div>
            )}
          </div>
          <div className='modal-footer'>
            <button className='btn btn-secondary btn-sm' onClick={handleClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewIcardRequestDetails
